import { Grid, IconButton, TextField } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import GetAppIcon from '@material-ui/icons/GetApp';
import ClearIcon from '@material-ui/icons/Clear';
import UndoIcon from '@material-ui/icons/Undo';
import React from 'react';
import Markdown from '../components/markdown';
import NavBar from '../components/navbar';
import { firebaseFirestore } from '../data/firebase';

const WAIT = 500;

class Editor extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            input: '',
            raw: '',
            timeout: null,
            preclear: '',
            displayUndo: false,
            saveButtonDisabled: false
        }
        this.save = this.save.bind(this);
        this.load = this.load.bind(this);
        this.download = this.download.bind(this);
        this.clear = this.clear.bind(this);
        this.undo = this.undo.bind(this);
    }

    // This should use FirebaseConnector
    async save() {
        const db = firebaseFirestore();
        await this.setState({
            saveButtonEnabled: true
        });
        await db.collection('editor').add({
                content: this.state.input,
                time: new Date().toISOString()
            }).then((docRef) => {
                alert('Saved with ID: ' + docRef.id);
            })
            .catch((error) => {
                console.log(error);
                alert('error: ' + error);
            });
        await this.setState({
            saveButtonEnabled: false
        });
    }

    // This should use FirebaseConnector
    async load() {
        const db = firebaseFirestore();
        const id = prompt('ID: ').replaceAll(' ', '');
        await db.collection('editor').doc(id).get().then((snapshot) => {
            const c = snapshot.data().content;
            this.setState({
                input: c,
                raw: c
            })
        })
        .catch((error) => {
            console.log(error);
            alert('error: ' + error);
        });
    }

    download() {
        const src = this.state.input;
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(src));
        var name = 'editor_' + new Date().getTime();
        if (src.startsWith('# '))
            name = src.split('\n', 1)[0].replace('\n', '').replace('\r', '').substring(2);
        name += '.md';
        element.setAttribute('download', name);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    clear() {
        if (this.state.input.length <= 0)
            return;
        clearTimeout(this.state.timeout);
        this.setState({
            preclear: this.state.input,
            input: '',
            raw: '',
            displayUndo: true
        });
    }

    undo() {
        this.setState({
            input: this.state.preclear,
            raw: this.state.preclear,
            displayUndo: false
        })
    }

    render() {
        return (
            <>
                <NavBar />
                {/* <style>
                    {'*{border: 1px solid red;}'}
                </style> */}
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    align-items="flex-start"
                    spacing={2}

                >
                    <Grid item key={'save'}>
                        <IconButton color="secondary" aria-label="save" component="span" onClick={() => this.save()} disabled={this.state.saveButtonDisabled}>
                            <SaveIcon />
                        </IconButton>
                    </Grid>
                    <Grid item key={'load'}>
                        <IconButton color="secondary" aria-label="load" component="span" onClick={() => this.load()}>
                            <FolderOpenIcon />
                        </IconButton>
                    </Grid>
                    <Grid item key={'download'}>
                        <IconButton color="secondary" aria-label="download" component="span" onClick={() => this.download()}>
                            <GetAppIcon />
                        </IconButton>
                    </Grid>
                    <Grid item key={'clear'}>
                        <IconButton color="secondary" aria-label="clear" component="span" onClick={() => this.clear()}>
                            <ClearIcon />
                        </IconButton>
                    </Grid>
                    <Grid item key={'undo'}>
                        <IconButton style={{display: this.state.displayUndo ? 'block' : 'none'}} color="secondary" aria-label="undo" component="span" onClick={() => this.undo()}>
                            <UndoIcon />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="stretch"
                >
                    <Grid item xs={6} key={'editor'}>
                        <TextField
                            autoFocus
                            fullWidth
                            multiline
                            value={this.state.input}
                            onChange={(e) => {
                                clearTimeout(this.state.timeout);
                                this.setState({
                                    input: e.target.value,
                                    timeout: setTimeout(() => this.setState({ raw: this.state.input }), WAIT)
                                });
                            }}
                            InputProps={{ disableUnderline: true }}
                        />
                    </Grid>
                    <Grid item xs={6} key={'outcome'}>
                        <Markdown source={this.state.raw} />
                    </Grid>
                </Grid>
            </>
        );
    }
}

export default Editor;